import React, { useContext } from "react";
import { AppContext } from "../../App";
import Can from "../can/Can";
import { cashFlow } from "../../rbac-consts";
import { default as AdminCashFlowTabsContainer } from "./admin/CashFlowTabsContainer";
import { default as ClientCashFlowTabsContainer } from "./client/CashFlowTabsContainer";

const CashFlowWrapper = () => {

  const { user } = useContext(AppContext);

  return (
    <>
      <Can
        role={user.roles}
        perform={cashFlow.ADMIN}
        yes={() => (
          <AdminCashFlowTabsContainer />
        )}
      />
      <Can
        role={user.roles}
        perform={cashFlow.USER}
        yes={() => (
          <ClientCashFlowTabsContainer />
        )}
      />
    </>
  );
};

export default CashFlowWrapper;